import {NgModule} from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {NumberInputComponent} from "./number-input.component";
import {MatInputModule} from "@angular/material/input";

@NgModule({
    declarations: [
        NumberInputComponent,
    ],
    exports: [
        NumberInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        MatInputModule,
    ]
})
export class NumberInputModule {}
